module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.openModal === true) ? _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.openModal
    }
  }, [_c('div', {
    staticClass: "frame visible"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "postcode-info"
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "content error-message"
  }, [_c('div', {
    staticClass: "error-icon",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/error-icon.png')"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.errorText[_vm.modalType]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "name": "dismiss"
    },
    on: {
      "click": _vm.dismissErrorMessage
    }
  }, [_vm._v("\n          Dismiss\n        ")])]) : _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.petitionCount) + " " + _vm._s(_vm.descriptionLine1))]), _vm._v(" "), _c('p', {
    staticClass: "description-line-2"
  }, [_vm._v(_vm._s(_vm.petitionGoal) + " " + _vm._s(_vm.descriptionLine2))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.postcode),
      expression: "postcode",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\d{4}$/
      }),
      expression: "{ required: true, regex: /^\\d{4}$/ }"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ENTER POSTCODE",
      "data-vv-name": "postcode",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SEARCH YOUR AREA")])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf907a28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/ThreatenedSpeciesModal.vue
// module id = 850
// module chunks = 0